import type { TaxConnectRequest, TaxConnectionView, TaxInvoiceRequest, TaxInvoiceView, PosStreamEvent } from 'shared-models/browser';
import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';

export const TAX_LIVE_EVENT = 'pos-tax-authority-update';
export type TaxLiveEvent = Extract<PosStreamEvent, { type: 'tax.connection.updated' | 'tax.invoice.updated' }>;
export function deliverTaxEvent(event: TaxLiveEvent) {
  window.dispatchEvent(new CustomEvent<TaxLiveEvent>(TAX_LIVE_EVENT, { detail: event }));
}

function options(employeeSession: string) { return { headers: { 'x-employee-session': employeeSession } }; }
function base(tenantId: string) { return `/tax-authority/tenant/${encodeURIComponent(tenantId)}`; }

export const taxAuthorityService = {
  async connection(tenantId: string, session: string): Promise<TaxConnectionView> {
    try { return (await authenticatedInstance.get<TaxConnectionView>(`${base(tenantId)}/connection`, options(session))).data; }
    catch (error) { throw new Error(extractServiceErrorMessage(error, 'טעינת החיבור לרשות המסים נכשלה')); }
  },
  async connect(tenantId: string, session: string, input: TaxConnectRequest): Promise<string> {
    try { return (await authenticatedInstance.post<{ authorizationUrl: string }>(`${base(tenantId)}/connect`, input, options(session))).data.authorizationUrl; }
    catch (error) { throw new Error(extractServiceErrorMessage(error, 'פתיחת החיבור לרשות המסים נכשלה')); }
  },
  async disconnect(tenantId: string, session: string): Promise<void> {
    try { await authenticatedInstance.delete(`${base(tenantId)}/connection`, options(session)); }
    catch (error) { throw new Error(extractServiceErrorMessage(error, 'ניתוק החיבור לרשות המסים נכשל')); }
  },
  async invoice(tenantId: string, session: string, orderId: number): Promise<TaxInvoiceView | null> {
    try { return (await authenticatedInstance.get<TaxInvoiceView | null>(`${base(tenantId)}/order/${orderId}/invoice`, options(session))).data; }
    catch (error) { throw new Error(extractServiceErrorMessage(error, 'טעינת ההקצאה נכשלה')); }
  },
  async allocate(tenantId: string, session: string, orderId: number, input: TaxInvoiceRequest): Promise<void> {
    try { await authenticatedInstance.post(`${base(tenantId)}/order/${orderId}/allocate`, input, options(session)); }
    catch (error) { throw new Error(extractServiceErrorMessage(error, 'בקשת ההקצאה נכשלה')); }
  },
};